const roleApi = {
  GETROLELISTBYPAGER: 'CSVPA-China/api/role/getListByPager', //角色列表
  GETROLELISTALL: 'CSVPA-China/api/role/getListAll', //所有权限
  SETPERMISSIONS: 'CSVPA-China/api/role/setPermissions' //设置权限
}

export default roleApi
